import { render, staticRenderFns } from "./PermissionsTeamsForm.vue?vue&type=template&id=055d5f60&scoped=true&"
import script from "./PermissionsTeamsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsTeamsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055d5f60",
  null
  
)

export default component.exports